import PSwitchCell from "./PSwitchCell";
export * from "./PSwitchCell";
export default PSwitchCell;
